import React, { useState } from "react";
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
} from "@mui/material";

import TextFieldsIcon from "@mui/icons-material/TextFields";
import EditIcon from "@mui/icons-material/Edit";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HighlightIcon from "@mui/icons-material/Highlight";
import ApprovalIcon from "@mui/icons-material/Approval";

import { styled } from "@mui/system";

// Styled Components
const IconWrapper = styled(Box)(({ theme, color }) => ({
  color: color,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "20px",
  width: "32px",
  height: "32px",
}));

const ForYou = ({ type, typeData, handleCanvasClick2, compPrimaryColor }) => {
  //   const { t } = useTranslation();
  const [hoveredItem, setHoveredItem] = useState(null);
  //   const primary_color = useSelector(selectPrimaryColor);
  const primary_color = "0px solid rgb(33 179 232)";

  const activeColor = "rgb(33 179 232)" || primary_color;

  // List items – order and labels match sidebar design (FOR ME)
  const forYouItems = [
    {
      name: "Text",
      type: "my_text",
      icon: <TextFieldsIcon fontSize="small" />,
    },
    {
      name: "My Signature",
      type: "my_signature",
      icon: <EditIcon fontSize="small" />,
    },
    {
      name: "My Initials",
      type: "my_initials",
      icon: <FormatItalicIcon fontSize="small" />,
    },
    {
      name: "Date Field",
      type: "date",
      icon: <CalendarTodayIcon fontSize="small" />,
    },
    {
      name: "Checkmark",
      type: "checkmark",
      icon: <CheckCircleIcon fontSize="small" />,
    },
    {
      name: "Highlight",
      type: "highlight",
      icon: <HighlightIcon fontSize="small" />,
    },
    {
      name: "Stamp",
      type: "stamp",
      icon: <ApprovalIcon fontSize="small" />,
    },
  ];

  return (
    <Box sx={{ width: "100%", overflow: "hidden" }}>
      <List
        sx={{
          width: "100%",
          p: 0, // Remove padding from List
          "& .MuiListItem-root": {
            p: 0, // Remove padding from ListItem
          },
        }}
      >
        {forYouItems.map((item, i) => (
          <ListItem
            key={i}
            disablePadding
            onClick={() => {
              type(item.type);
              handleCanvasClick2 && handleCanvasClick2(item.type);
            }}
            onMouseEnter={() => setHoveredItem(i)}
            onMouseLeave={() => setHoveredItem(null)}
            sx={{
              backgroundColor:
                typeData === item.type
                  ? "rgba(33, 179, 232, 0.16)"
                  : hoveredItem === i
                  ? "rgba(33, 179, 232, 0.08)"
                  : "transparent",
              borderRadius: "4px",
              mb: 0.5,
              transition: "all 0.2s ease",
            }}
          >
            <ListItemButton
              sx={{
                minHeight: "32px",
                borderRadius: "4px",
                alignItems: "flex-start",
                py: 0.75,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: "32px",
                  m: 0,
                  mt: "2px",
                }}
              >
                <IconWrapper
                  color={typeData === item.type ? "rgb(33, 179, 232)" : "rgba(0, 0, 0, 0.54)"}
                  sx={{ width: "24px", height: "24px" }}
                >
                  {React.cloneElement(item.icon, {
                    sx: {
                      fontSize: "18px", // Smaller icon size
                      transition: "all 0.2s ease",
                    },
                  })}
                </IconWrapper>
              </ListItemIcon>
              <ListItemText
                primary={item.name}
                sx={{
                  m: 0,
                  "& .MuiListItemText-primary": {
                    fontSize: "15px",
                    fontWeight: typeData === item.type ? 600 : 400,
                    color:
                      typeData === item.type ? "rgba(0, 0, 0, 0.87)" : "rgba(0, 0, 0, 0.87)",
                    whiteSpace: "normal",
                    overflow: "visible",
                    lineHeight: 1.3,
                  },
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default ForYou;
